import { Component } from '@angular/core';
import { IonSkeletonText } from '@ionic/angular';

@Component({
  selector: 'nty-discussion-list-skeleton-loader',
  imports: [IonSkeletonText],
  template: `
    @for (row of skeletonRows; track row) {
      <div class="wrapper">
        <ion-skeleton-text [animated]="true" />
      </div>
    }
  `,
  styles: `
    @use 'terra';

    .wrapper {
      height: 116px;
      margin: 12px auto;
      max-width: 93%;
      @include terra.radius(medium);
    }
  `,
})
export class DiscussionListSkeletonLoaderComponent {
  skeletonRows = Array(6);
}
